const BASE_URL = 'https://gateway.sitbogota.com';

export const environment = {
  production: false,

  mapbox: {
    accessToken:'pk.eyJ1Ijoic2l0LWFsbWVyaWEiLCJhIjoiY2xoNm42NXQ3MDduOTNmbWloZjY5b2pqNiJ9.wtGqg3Zm9_EvOYPpR1c5ZQ',
    style:      'mapbox://styles/sit-almeria/clk8fki8k02zm01nm7rjk6nvo',
    zoom:   12.54,
    center: [-74.056307, 4.695538],
  },

  geoLocations: {
    bounds:{
      swlat:  36.834047,
      swlng:  -2.4637136,
      nelat:  36.841728,
      nelng:  -2.4513164,
    },
    apiKey:       'AIzaSyCSSsVGZG4TRyzGnX69mAr8G0ZkbvYEqxM',
    getAddressUrl:'https://maps.googleapis.com/maps/api/geocode',
  },

  mqtt : {
    hostname  : "broker.sit-almeria.com",
    protocol  : "wss",
    port      : 443,
    path      : "/mqtt",
    username  : "SubUserFrontEnd",
    password  : "G#p9@zQ2v*",
    topic     : "test/almeria"

  },

  authUrl:          `${BASE_URL}/auth/api/v1`,
  alertUrl:         `${BASE_URL}/alerts/api/v1`,
  userUrl:          `${BASE_URL}/auth/api/v1`,
  agentsUrl:        `${BASE_URL}/agents/api/v1`,
  camerasUrl:       `${BASE_URL}/camera/api/v1`,
  cctvUrl:          `${BASE_URL}/cctv/api/v1/camera-streaming`,
  environmentalUrl: `${BASE_URL}/environmental/api/v1`,
  incidentUrl:      `${BASE_URL}/incidents/api/v1`,
  role:             `${BASE_URL}/auth/api/v1/rol/`,
  status:           `${BASE_URL}/api/v1/status`,
  trafficUrl:       `${BASE_URL}/traffic/api/v1`,
  type:             `${BASE_URL}/auth/api/v1/document-type/`,
  vmsUrl:           `${BASE_URL}/vms/api/v1`,
  auditUrl:         `${BASE_URL}/audit/api/v1`,
  runwayUrl:        `${BASE_URL}/runway/api/v1`,
  parkingUrl:       `${BASE_URL}/parking/api/v1`,
  luminary:       `${BASE_URL}/luminaries/api/v1`,
  cameraStream:       `${BASE_URL}/camera/api/v1`,

  //Notifications
  wsAlertsUrl:              `wss://qa-gateway.sit-almeria.com/websocket`,

  almeriaRunwayUrl: `http://34.69.231.124:8600/geoserver/RutasAlmeria/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=RutasAlmeria%3AParadas&maxFeatures=400&outputFormat=application%2Fjson`,

  geoApiPageSize: 100,

  keycloak: {
    clientId:     'web-client',
     issuer:       'https://kc-enel.sitbogota.com/auth/realms/enel-qa',
    redirectUri:   window.location.origin + '/visor-mapa',
    responseType: 'code',
    scope:        'openid profile email',
    requireHttps:  false,
    disableAtHashCheck:   true,
    showDebugInformation: true,
  }
};

export default environment;
